import { render } from "./TermsOfUse.vue?vue&type=template&id=046ed0c7&ts=true"
import script from "./TermsOfUse.vue?vue&type=script&lang=ts"
export * from "./TermsOfUse.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__